"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountingExportV2ChangesResponseSchema = exports.accountingExportV2ChangesQuerySchema = exports.accountingExportV2RecordSchema = exports.accountingExportV2RefundRecordSchema = exports.accountingExportV2PaymentRecordSchema = exports.accountingExportV2InvoiceRecordSchema = exports.accountingExportV2TaxRateRecordSchema = exports.accountingExportV2ItemRecordSchema = exports.accountingExportV2CustomerRecordSchema = exports.accountingExportV2RecordStatusSchema = exports.accountingExportV2EntityTypeSchema = exports.accountingExportInvoicesResponseSchema = exports.accountingExportCustomersResponseSchema = exports.accountingExportInvoiceSchema = exports.accountingExportCustomerSchema = exports.ACCOUNTING_EXPORT_V2_CONTRACT_VERSION = void 0;
const zod_1 = require("zod");
exports.ACCOUNTING_EXPORT_V2_CONTRACT_VERSION = 2;
const optionalTextSchema = zod_1.z.string().trim().min(1).nullable();
exports.accountingExportCustomerSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    displayName: zod_1.z.string().trim().min(1),
    email: optionalTextSchema,
    phone: optionalTextSchema,
    billingAddress: zod_1.z
        .object({
        line1: zod_1.z.string().trim().min(1),
        line2: optionalTextSchema,
        city: zod_1.z.string().trim().min(1),
        state: zod_1.z.string().trim().min(1),
        postalCode: zod_1.z.string().trim().min(1),
        country: zod_1.z.literal("US"),
    })
        .nullable(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.accountingExportInvoiceSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    invoiceNumber: zod_1.z.number().int().positive(),
    customerId: zod_1.z.string().uuid(),
    customerName: zod_1.z.string().trim().min(1),
    status: zod_1.z.enum(["OPEN", "VOID"]),
    financialStatus: zod_1.z.enum(["UNPAID", "PARTIALLY_PAID", "PAID"]).nullable(),
    dueAt: zod_1.z.string().datetime(),
    issuedAt: zod_1.z.string().datetime().nullable(),
    currency: zod_1.z.literal("USD"),
    subtotalCents: zod_1.z.number().int().min(0),
    taxCents: zod_1.z.number().int().min(0),
    totalCents: zod_1.z.number().int().min(0),
    balanceCents: zod_1.z.number().int().min(0),
    lines: zod_1.z.array(zod_1.z.object({
        name: zod_1.z.string().trim().min(1),
        description: optionalTextSchema,
        quantityMilli: zod_1.z.number().int().positive(),
        unitPriceCents: zod_1.z.number().int().min(0),
        lineTotalCents: zod_1.z.number().int().min(0),
    })),
    updatedAt: zod_1.z.string().datetime(),
});
exports.accountingExportCustomersResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.accountingExportCustomerSchema),
});
exports.accountingExportInvoicesResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.accountingExportInvoiceSchema),
});
exports.accountingExportV2EntityTypeSchema = zod_1.z.enum([
    "CUSTOMER",
    "ITEM",
    "TAX_RATE",
    "INVOICE",
    "PAYMENT",
    "REFUND",
]);
exports.accountingExportV2RecordStatusSchema = zod_1.z.enum([
    "ACTIVE",
    "ARCHIVED",
    "OPEN",
    "VOID",
    "RECORDED",
    "REVERSED",
    "SUCCEEDED",
]);
const accountingExportV2RecordBaseSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.ACCOUNTING_EXPORT_V2_CONTRACT_VERSION),
    id: zod_1.z.string().trim().min(1).max(200),
    sourceUpdatedAt: zod_1.z.string().datetime({ offset: true }),
    sourceFingerprint: zod_1.z.string().regex(/^[a-f0-9]{64}$/),
});
exports.accountingExportV2CustomerRecordSchema = accountingExportV2RecordBaseSchema.extend({
    entityType: zod_1.z.literal("CUSTOMER"),
    status: zod_1.z.enum(["ACTIVE", "ARCHIVED"]),
    displayName: zod_1.z.string().trim().min(1).max(160),
    email: optionalTextSchema,
    phone: optionalTextSchema,
    billingAddress: exports.accountingExportCustomerSchema.shape.billingAddress,
});
exports.accountingExportV2ItemRecordSchema = accountingExportV2RecordBaseSchema.extend({
    entityType: zod_1.z.literal("ITEM"),
    status: zod_1.z.enum(["ACTIVE", "ARCHIVED"]),
    itemType: zod_1.z.enum(["SERVICE", "MATERIAL"]),
    name: zod_1.z.string().trim().min(1).max(160),
    code: optionalTextSchema,
    description: optionalTextSchema,
    unitPriceCents: zod_1.z.number().int().nonnegative(),
    taxable: zod_1.z.boolean(),
    incomeAccountHint: zod_1.z.literal("SERVICE_REVENUE"),
});
exports.accountingExportV2TaxRateRecordSchema = accountingExportV2RecordBaseSchema.extend({
    entityType: zod_1.z.literal("TAX_RATE"),
    status: zod_1.z.literal("ACTIVE"),
    name: zod_1.z.string().trim().min(1).max(100),
    rateMilliPercent: zod_1.z.number().int().min(0).max(100_000),
});
const accountingExportV2InvoiceLineSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    catalogItemId: zod_1.z.string().uuid().nullable(),
    position: zod_1.z.number().int().nonnegative(),
    name: zod_1.z.string().trim().min(1).max(160),
    description: optionalTextSchema,
    quantityMilli: zod_1.z.number().int().positive(),
    unitPriceCents: zod_1.z.number().int().nonnegative(),
    lineTotalCents: zod_1.z.number().int().nonnegative(),
    taxable: zod_1.z.boolean(),
});
exports.accountingExportV2InvoiceRecordSchema = accountingExportV2RecordBaseSchema.extend({
    entityType: zod_1.z.literal("INVOICE"),
    status: zod_1.z.enum(["OPEN", "VOID"]),
    invoiceNumber: zod_1.z.number().int().positive(),
    customerId: zod_1.z.string().uuid(),
    customerName: zod_1.z.string().trim().min(1).max(160),
    issuedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    dueAt: zod_1.z.string().datetime({ offset: true }),
    voidedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    voidReason: optionalTextSchema,
    currency: zod_1.z.literal("USD"),
    subtotalCents: zod_1.z.number().int().nonnegative(),
    taxableSubtotalCents: zod_1.z.number().int().nonnegative(),
    taxRateMilliPercent: zod_1.z.number().int().min(0).max(100_000),
    taxCents: zod_1.z.number().int().nonnegative(),
    totalCents: zod_1.z.number().int().nonnegative(),
    lines: zod_1.z.array(accountingExportV2InvoiceLineSchema).min(1),
});
const accountingExportV2PaymentAllocationSchema = zod_1.z.object({
    invoiceId: zod_1.z.string().uuid(),
    amountCents: zod_1.z.number().int().positive(),
});
exports.accountingExportV2PaymentRecordSchema = accountingExportV2RecordBaseSchema.extend({
    entityType: zod_1.z.literal("PAYMENT"),
    status: zod_1.z.enum(["RECORDED", "REVERSED"]),
    customerId: zod_1.z.string().uuid(),
    method: zod_1.z.enum([
        "CASH",
        "CHECK",
        "CARD",
        "CARD_EXTERNAL",
        "BANK_TRANSFER",
        "OTHER",
    ]),
    source: zod_1.z.enum(["MANUAL", "PROVIDER"]),
    amountCents: zod_1.z.number().int().positive(),
    currency: zod_1.z.literal("USD"),
    receivedAt: zod_1.z.string().datetime({ offset: true }),
    reversedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    reference: optionalTextSchema,
    allocations: zod_1.z.array(accountingExportV2PaymentAllocationSchema).min(1),
});
exports.accountingExportV2RefundRecordSchema = accountingExportV2RecordBaseSchema.extend({
    entityType: zod_1.z.literal("REFUND"),
    status: zod_1.z.literal("SUCCEEDED"),
    customerId: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid(),
    paymentId: zod_1.z.string().uuid(),
    amountCents: zod_1.z.number().int().positive(),
    currency: zod_1.z.literal("USD"),
    completedAt: zod_1.z.string().datetime({ offset: true }),
    reason: zod_1.z.string().trim().min(1).max(4_000),
});
exports.accountingExportV2RecordSchema = zod_1.z.discriminatedUnion("entityType", [
    exports.accountingExportV2CustomerRecordSchema,
    exports.accountingExportV2ItemRecordSchema,
    exports.accountingExportV2TaxRateRecordSchema,
    exports.accountingExportV2InvoiceRecordSchema,
    exports.accountingExportV2PaymentRecordSchema,
    exports.accountingExportV2RefundRecordSchema,
]);
exports.accountingExportV2ChangesQuerySchema = zod_1.z.object({
    cursor: zod_1.z.string().trim().min(1).max(4_096).optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(250).default(100),
});
exports.accountingExportV2ChangesResponseSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.ACCOUNTING_EXPORT_V2_CONTRACT_VERSION),
    sourceOfTruth: zod_1.z.literal("CREWFSM_OUTBOUND"),
    items: zod_1.z.array(exports.accountingExportV2RecordSchema),
    nextCursor: zod_1.z.string().trim().min(1).max(4_096).nullable(),
    hasMore: zod_1.z.boolean(),
});
//# sourceMappingURL=accounting-export.js.map